"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LabelValueDisplay = _interopRequireDefault(require("01_core/components/layout/LabelValueDisplay"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _InputDateTime = _interopRequireDefault(require("01_core/components/select/InputDateTime"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _kansaResultActions = require("../../kansaResultActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * スタイル
 */
const RootGrid = (0, _styles.styled)(_Grid.default)({
  whiteSpace: 'pre-line'
});
const BoxDisp = (0, _styles.styled)('div')({
  margin: 'auto 0'
});
const UnderSpaceGrid = (0, _styles.styled)(_Grid.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginBottom: theme.spacing(2)
  };
});

/**
 * ユーザ情報
 */
function ShitekiJiko(props) {
  const {
    intl,
    shitekiJiko,
    mode,
    setShitekiEntries,
    shitekiEntriesList,
    kansaTgtNendoNm,
    getCodeName,
    errors,
    getCodeItems
  } = props;
  const key = shitekiJiko.shitekijikoKbnCd + shitekiJiko.no;
  const fieldErrors = errors || {};
  const patchedGetCodeItems = kbn => {
    const items = getCodeItems ? getCodeItems(kbn) : [];
    if (kbn === _CodeConsts.CODE.MONTHS.KBN) {
      return items.map(item => _objectSpread(_objectSpread({}, item), {}, {
        value: String(item.value).padStart(2, '0')
      }));
    }
    return items;
  };
  return /*#__PURE__*/_react.default.createElement(RootGrid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, mode === _kansaResultActions.CONTENTS.SHITEKI_OLD_DETAIL ?
  /*#__PURE__*/
  // 詳細版の場合
  _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_JIKO_KBN
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(_CodeConsts.CODE.KANSA_STK_KBN.CODE_1 === shitekiJiko.shitekijikoKbnCd ? getCodeName(_CodeConsts.CODE.KANSA_STK_KBN.KBN, shitekiJiko.shitekijikoKbnCd) : kansaTgtNendoNm + getCodeName(_CodeConsts.CODE.KANSA_STK_KBN.KBN, shitekiJiko.shitekijikoKbnCd)))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHO_TITLE
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(shitekiJiko.chapterTitle))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_YOKYU_JIKO
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(shitekiJiko.yokyuJiko))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_HAKKEN_JIKO_BUNRUI
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.KANSA_HKN_BNR.KBN, shitekiJiko.hakkenjikoBunruiCd)))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_HAKKEN_JIKO
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(shitekiJiko.hakkenjiko))
  }))) :
  /*#__PURE__*/
  // 詳細版でない場合
  _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_JIKO_KBN
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(_CodeConsts.CODE.KANSA_STK_KBN.CODE_1 === shitekiJiko.shitekijikoKbnCd ? getCodeName(_CodeConsts.CODE.KANSA_STK_KBN.KBN, shitekiJiko.shitekijikoKbnCd) : kansaTgtNendoNm + getCodeName(_CodeConsts.CODE.KANSA_STK_KBN.KBN, shitekiJiko.shitekijikoKbnCd)))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_KAKUNIN_JIKO
    })),
    value: !shitekiJiko.kakushoExp ? /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(shitekiJiko.kakuninJiko)) : /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(shitekiJiko.kakuninJiko), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_KAKUSHO_EXM
    }), /*#__PURE__*/_react.default.createElement("br", null), shitekiJiko.kakushoExp)
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_KAKUNIN_KEKKA
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.KANSA_KKNN_RSLT.KBN, shitekiJiko.kakuninKekkaCd)))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_KAKUNIN_HOSOKU
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(shitekiJiko.kakuninHosoku))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_HAKKEN_JIKO_BUNRUI
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.KANSA_HKN_BNR.KBN, shitekiJiko.hakkenjikoBunruiCd)))
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: /*#__PURE__*/_react.default.createElement(BoxDisp, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_HAKKEN_JIKO
    })),
    value: /*#__PURE__*/_react.default.createElement(BoxDisp, null, _stringUtil.default.emptyToHyphen(shitekiJiko.hakkenjiko))
  }))), mode === _kansaResultActions.CONTENTS.SHITEKI_ENTRY ?
  /*#__PURE__*/
  // 登録画面の場合
  _react.default.createElement(UnderSpaceGrid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 8,
      lg: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_TAISAKU
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: shitekiEntriesList[key].taisaku,
    onChange: setShitekiEntries && setShitekiEntries(key, 'taisaku'),
    maxLength: 500,
    multiline: true,
    rows: 6,
    error: !!fieldErrors.taisaku,
    helperText: fieldErrors.taisaku
  })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      lg: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_TANTOSHA
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: shitekiEntriesList[key].hikansabumonTantoshaNm,
    onChange: setShitekiEntries && setShitekiEntries(key, 'hikansabumonTantoshaNm'),
    maxLength: 64,
    error: !!fieldErrors.hikansabumonTantoshaNm,
    helperText: fieldErrors.hikansabumonTantoshaNm
  })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_PLAN_SAKUTEIJI
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      lg: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_COMP_YOTEI_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: shitekiEntriesList[key].planningCompYoteiDate,
    onChange: setShitekiEntries && setShitekiEntries(key, 'planningCompYoteiDate'),
    dateOnly: true,
    error: !!fieldErrors.planningCompYoteiDate,
    helperText: fieldErrors.planningCompYoteiDate,
    getCodeItems: patchedGetCodeItems
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      lg: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONIN_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: shitekiEntriesList[key].planningShoninDate,
    onChange: setShitekiEntries && setShitekiEntries(key, 'planningShoninDate'),
    dateOnly: true,
    error: !!fieldErrors.planningShoninDate,
    helperText: fieldErrors.planningShoninDate,
    getCodeItems: patchedGetCodeItems
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      lg: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONINSHA
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: shitekiEntriesList[key].planningShoninshaNm,
    onChange: setShitekiEntries && setShitekiEntries(key, 'planningShoninshaNm'),
    maxLength: 64,
    error: !!fieldErrors.planningShoninshaNm,
    helperText: fieldErrors.planningShoninshaNm
  }))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_TAIO_COMP
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      lg: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_COMP_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: shitekiEntriesList[key].taiocompCompDate,
    onChange: setShitekiEntries && setShitekiEntries(key, 'taiocompCompDate'),
    dateOnly: true,
    name: 'taiocompCompDate',
    error: !!fieldErrors.taiocompCompDate,
    helperText: fieldErrors.taiocompCompDate,
    getCodeItems: patchedGetCodeItems
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      lg: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONIN_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: shitekiEntriesList[key].taiocompCompShoninDate,
    onChange: setShitekiEntries && setShitekiEntries(key, 'taiocompCompShoninDate'),
    dateOnly: true,
    name: 'taiocompCompShoninDate',
    error: !!fieldErrors.taiocompCompShoninDate,
    helperText: fieldErrors.taiocompCompShoninDate,
    getCodeItems: patchedGetCodeItems
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6,
      lg: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONINSHA
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: shitekiEntriesList[key].taiocompCompShoninshaNm,
    onChange: setShitekiEntries && setShitekiEntries(key, 'taiocompCompShoninshaNm'),
    maxLength: 64,
    error: !!fieldErrors.taiocompCompShoninshaNm,
    helperText: fieldErrors.taiocompCompShoninshaNm
  })))))) :
  /*#__PURE__*/
  // 表示のみの場合
  _react.default.createElement(UnderSpaceGrid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_TAISAKU
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].taisaku)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_TANTOSHA
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].hikansabumonTantoshaNm)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_PLAN_SAKUTEIJI
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_COMP_YOTEI_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].planningCompYoteiDate)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONIN_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].planningShoninDate)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONINSHA
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].planningShoninshaNm)))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_TAIO_COMP
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_COMP_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].taiocompCompDate)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONIN_DATE
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].taiocompCompShoninDate)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHITEKI_SHONINSHA
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shitekiEntriesList[key].taiocompCompShoninshaNm)))))))));
}
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)(ShitekiJiko));